<template>
  <div class="diadin">

    <div class="title">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item>
          <el-input :placeholder="$t('menu.Title')" clearable v-model="formInline.title"></el-input>

        </el-form-item>
        <el-form-item>
          <el-select class="cinput" v-model="formInline.mcSeriesModel" :placeholder="$t('menu.ScopeOfApplication')"
            clearable>
            <el-option v-if="inle == 'zh'" v-for="(item, index) in cheList" :key="index" :label="item.seriesModel"
              :value="item.id"></el-option>
            <el-option v-if="inle !== 'zh'" v-for="(item, index) in cheList" :key="index" :label="item.seriesModelEn"
              :value="item.id"></el-option>

          </el-select>
          <el-button type="primary" @click="search">{{ $t('menu.search') }}</el-button>
        </el-form-item>
      </el-form>
      <div class="bonntbot">
        <el-tabs v-model="action" @tab-click="searchType">
          <el-tab-pane v-for="(item, index) in titleList" :key="index" :label="item.dictLabel"
            :name="item.dictLabel"></el-tab-pane>


        </el-tabs>


      </div>
      <!-- <div class="status">
        <div v-for="item in titleList" :key="item.dictValue" @click="searchType(item.dictValue)">{{ item.dictLabel }}</div>
      </div> -->
    </div>




    <el-table  empty-text=" " :data="mation" style="width: 100%" stripe border highlight-current-row>
      <el-table-column prop="fileName" :label="$t('menu.Title')">
        <template slot-scope="scope">
          <!-- <p>{{ inle == 'zh' ? scope.row.fileName : scope.row.fileNameEn }}.{{ formatTitle(scope.row) }}</p> -->
            <p>{{ scope.row.fileName }}.{{ formatTitle(scope.row) }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="fileName" :label="$t('menu.ApplicableModels')">
        <template slot-scope="scope">
          <p v-if="scope.row.mcSeriesModel!==null">{{ formatChe(scope.row.mcSeriesModel) }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" :label="$t('menu.ReleaseTime')" width="280"> </el-table-column>
      <el-table-column prop="vin" width="180" :label="$t('menu.Operation')">
        <template slot="label">
          <div>{{ $t('menu.Operation') }}</div>
        </template>

        <template slot-scope="scope">
          <div class="btn">
            <el-button type="text" size="mini" @click="downurl(scope.row, formatTitle(scope.row))">{{ $t('menu.Preview')
              }}</el-button>
            <!-- <el-button type="text" size="mini" v-if="typ=='zip'" > 
              <a :href="scope.row.filePath" :download="`${scope.row.fileName} ` + '.' + typ">{{ $t('menu.Download') }}1{{ typ }}</a>
            </el-button> -->
              <el-button type="text" size="mini"  >
              <a :href="ncodeUrlPath(scope.row.filePath)" :download="`${scope.row.fileName} ` + '.' + typ">{{ $t('menu.Download') }}</a>
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="bottompage">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage3"
        :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" layout="total,sizes, prev, pager, next" :total="totale">
      </el-pagination>

    </div>

    <div></div>
    <el-dialog :title="ylTitle" :visible.sync="dialogVisible" width="80%" :before-close="handleClose">

      <div v-if="typ == 'txt'" v-html="txtUrl">

      </div>
      <video v-if="typ == 'mp4'" controls>
        <source :src="videoUrl" type="video/mp4">
      </video>
      <yl v-if="typ == 'pdf'" :url="videoUrl" :typ="'pdf'"></yl>
      <!-- <iframe v-if="typ == 'pdf'" :src="videoUrl"  width="100%" height="800px" /> -->
       <!-- <iframe v-if="typ == 'pdf'"  frameborder="0" :src="videoUrl"  width="100%" height="800px" /> -->
      <yl v-if="typ == 'xlsx'" :url="aurl" :typ="'xlsx'"></yl>
      <yl v-if="typ == 'docx'" :url="aurl" :typ="'docx'"></yl>
      <yl v-if="typ == 'excel'" :url="aurl" :typ="'excel'"></yl>
      <img v-if="typ == 'png' || typ == 'jpg' || typ == 'jepg'" :src="imgurl" alt="">
      <iframe v-if="typ !== 'png' && typ !== 'jpg' && typ !== 'jepg' && typ !== 'mp4' && typ !== 'txt' && typ !== 'pdf'&& typ !== 'xlsx'&& typ !== 'docx'&& typ !== 'excel'"
        :src='aurl' style="width: 100%; height: 70vh" frame />
    </el-dialog>

  </div>
</template>
<script type="text/javascript" src="https://cdn.jsdelivr.net/npm/js-base64@3.6.0/base64.min.js"></script>
<script>
import { documentList, querytype, listMcSeriesModels } from "../../api/api";
import axios from "axios"
import yl from '../../components/yl' //发票
export default {
   components: {
    yl
   
  },
  data () {
    return {
      currentPage3: 1,
      dialogVisible: false,
      pagesize: 10,
      aurl: '',
      totale: 3,
      activeName: "first",
      mation: [], //列表
      action: this.$t('menu.All'),
      titleList: [
        {
          dictValue: '',
          dictLabel: this.$t('menu.All')
        }
      ],
      formInline: {
        title: "",
        status: "",
        startTime: "",
        endTime: "",
        contact: "",
        category: "",
        type: "",
        mcSeriesModel: '',
      },
      inle: 'zh',
      ylTitle: '',
      a: false,
      b: false,
      cheList: [],
      txtUrl: '',
      typ: '',
      videoUrl: '',
      imgurl: ''
    };
  },
  created () {
    let a = sessionStorage.getItem('i18n')
    this.inle = a
    this.biao();
    this.getQuerytype()
    this.getListMcSeriesModels()

  },
  methods: {
    ncodeUrlPath(url) {
  // 找到最后一个 '/' 的位置
  const lastSlashIndex = url.lastIndexOf('/');

  // 如果没有找到 '/', 直接返回原字符串
  if (lastSlashIndex === -1) {
    return url;
  }

  // 提取最后一个 '/' 之前的部分（包括 '/'）
  const prefix = url.substring(0, lastSlashIndex + 1); 

  // 提取最后一个 '/' 之后的部分（文件名）
  const fileName = url.substring(lastSlashIndex + 1);


   let str = url
      let b = ''
    

        b = str.substring(str.lastIndexOf(".") + 1, str.length);
        // console.log(b)
    if(b=='zip'){
        return url;
    }
      // console.log(123123,b);
  
  // 对文件名部分进行 encodeURIComponent 转码
  const encodedFileName = encodeURIComponent(fileName);

  // 拼接返回
  return prefix + encodedFileName;
},
     sxtitle(e){
      let a =''
       
      if(this.inle=='zh'){
        a=e.dictLabel
      }
    if(this.inle=='en'){
      if(e.dictLabelEn.indexOf(":") !== -1){
       
        let c =JSON.parse(e.dictLabelEn)
     
        a=c.en
      }else{
        a=e.dictLabelEn
      }
      

      }
      if(this.inle=='de'){
         if(e.dictLabelEn.indexOf(":") !== -1){
             let d =JSON.parse(e.dictLabelEn)
a=d.de
         } else{
        a=e.dictLabelEn
      } 
         
      
      }
      return a

    },
    formatTitle (row) {

      let str = row.filePath
      let b = ''
      if (row !== '') {

        b = str.substring(str.lastIndexOf(".") + 1, str.length);
        // console.log(b)
      }
      return b
    },
    handleClose (done) {
      done();
    },
    formatChe (ids) {
      let arr = ids.split(',')
      let str = []
      arr.forEach(item => {
        // console.log(item)
        this.cheList.forEach(i => {
          // console.log(i)
          if (item == i.id && this.inle == 'zh') {
            str.push(i.seriesModel)
          }
          if (item == i.id && this.inle !== 'zh') {
            str.push(i.seriesModelEn)
          }
        })
      })
      // console.log(str)
      return str.join(',')
    },
    getListMcSeriesModels () {
      listMcSeriesModels().then(r => {
        this.cheList = r.data.data
      })
    },
    getQuerytype () {
      const params = new URLSearchParams()
      querytype(
        params,
        'sys_document_category'
      ).then(r => {
        if (r.data.code == 200) {
          r.data.data.forEach(i => {
             i.dictLabel= this.sxtitle(i)
            
            this.titleList.push(i)

          })
        }
      })
    },
    searchType (tab, event) {
      this.action = tab.label
      // console.log(tab);

      this.formInline.category = this.titleList[tab.index].dictValue
      this.biao()
    },
    search () {
      this.biao()
    },
    async biao () {
      let param = new URLSearchParams();
      let category = this.formInline.category;
      let type = this.formInline.type;
      let startTime = this.formInline.startTime;
      let endTime = this.formInline.endTime;
      let status = this.formInline.status;
      let searchValue = this.formInline.title;
      const { data: res } = await documentList(
        param,
        this.formInline.mcSeriesModel,
        category,
        type,
        startTime,
        endTime,
        status,
        searchValue,
        this.currentPage3,
        this.pagesize
      );

      this.mation = res.rows.filter(item => item.status != 0);
      this.totale = res.total;
    },

    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
      this.pagesize=val
      this.biao()
    },
    handleCurrentChange (val) {
      this.currentPage3=val
      this.biao();
    },
    base64Encode(e){
  var rv;
  rv = encodeURIComponent(e);
  rv = unescape(rv);
  rv = window.btoa(rv);
  return rv;
},
   async downurl (row, e) {
      this.txtUrl = ''
      this.videoUrl = ''
      this.typ = e
      console.log(e);

        let a =sessionStorage.getItem('i18n')
        if(a=='zh'){
          this.ylTitle = row.fileName
        }else{
          this.ylTitle = row.fileNameEn 
        }
   
      // this.aurl='https://view.officeapps.live.com/op/view.aspx?src=https://dms.bendamoto.com/bendaFDMSWeb' + row.filePath
      // this.aurl = 'https://view.bendamoto.com/onlinePreview?url='+encodeURIComponent(this.base64Encode(row.filePath))

this.aurl =row.filePath

      if (e == 'txt') {
        // axios.get('https://dms.bendamoto.com/bendaFDMSWeb' + row.filePath, { responseType: 'text' })
        axios.get( row.filePath, { responseType: 'text' })
          .then(response => {
            // 根据设置的编码进行处理，这里假定utf-8
            this.txtUrl = response.data;
          })

      }
      if (e == 'mp4') {
        // this.videoUrl = 'https://dms.bendamoto.com/bendaFDMSWeb' + row.filePath
        this.videoUrl = row.filePath
      }
      if (e == 'pdf') {
        // this.videoUrl = 'https://dms.bendamoto.com/bendaFDMSWeb' + row.filePath
        

// var url = row.filePath; //要预览文件的访问地址
// window.open('http://127.0.0.1:8012/onlinePreview?url='+encodeURIComponent(Base64.encode(previewUrl)));
        // this.videoUrl = 'https://view.bendamoto.com/onlinePreview?url='+encodeURIComponent(this.base64Encode(row.filePath))
        this.videoUrl = row.filePath
        console.log( 1,this.videoUrl);


        
      }
      if (e == 'png' || e == 'jpg' || e == 'jepg') {
        // this.videoUrl = 'https://dms.bendamoto.com/bendaFDMSWeb' + row.filePath
        this.imgurl = row.filePath
      }
      console.log(123, this.imgurl);
      this.dialogVisible = true
    },
    downLoad (row) {
      console.log(row)
      // const fileURL = 'https://dms.bendamoto.com/bendaFDMSWeb' + row.filePath; // 替换为你的文件URL
      const fileURL =  row.filePath; // 替换为你的文件URL
      // console.log(fileURL)
      // const link = document.createElement('a');
      // // 这里是将链接地址url转成blob地址，
      // fetch(fileURL).then(res => res.blob()).then(blob => {
      //   link.href = URL.createObjectURL(blob)
      //   // 下载文件的名称及文件类型后缀
      //   link.download = `${row.fileName} ` + '.' + this.typ;
      //   document.body.appendChild(link)
      //   link.click()
      //   //在资源下载完成后 清除 占用的缓存资源
      //   window.URL.revokeObjectURL(link.href);
      //   document.body.removeChild(link);
      // });

      const src = `${fileURL}?t=${new Date().getTime()}`
      fetch(src).then(res => {
        res.blob().then(myBlob => {
          const href = URL.createObjectURL(myBlob)
          const a = document.createElement('a')
          a.href = href
          a.download = `${row.fileName} ` + '.' + this.typ;
          a.click()
          a.remove()
        })
      })
    

    }
  },
};
</script>

<style lang="less" scoped>
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.cinput {
  width: 300px;
  margin-right: 10px;
}

.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  padding-left: 0;
}

.bonntbot {
  display: flex;
  justify-content: space-between;
  align-items: center;

}

.bottompage {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

/deep/.el-table {
  min-height: 750px !important;
}

/deep/.el-table__body td {
  padding: 20px !important;
  padding-left: 0 !important;
  text-align: left;
}

/deep/.el-table th.is-leaf {
  text-align: left;
}

/deep/.el-tabs {
  height: 97%;
  width: 100%;
}

/deep/.el-tabs__content {
  width: 100%;
  height: 100%;
}

/deep/.el-table--scrollable-x .el-table__body-wrapper {
  height: 90%;
}

/deep/.el-tab-pane {
  height: 82%;
}

/deep/.el-table--fit {
  height: 94%;
}

.xz-box {
  width: 400px;
  margin: 0 auto;
}

.btn {
  display: flex;
  justify-content: space-evenly;
  color: #31aff2;
}

/deep/.el-dialog__body {
  overflow: auto;
}

.title {
  padding-bottom: 10px;


  .status {
    display: flex;
    margin-top: 20px;

    div {
      margin-right: 25px;
      cursor: pointer;
    }
  }
}
a{text-decoration:none;color: #409EFF;}
 
a:hover{text-decoration:underline}
</style>